import IconButton from "@material-ui/core/IconButton";
import VerticalThreeDots from "../../../assets/dashboardIcons/verticalThreeDots";
import React, { useState } from "react";
import { StyledMenu } from "../../../components/threeDotsPopupMenuNew/styles";
import {
  StyledButton,
  StyledMenuItem,
} from "../../underwriters/components/allClientsTable/styles";

type ActionMenuProps = {
  onViewESUB: () => void;
  onAcceptAsAccount: () => void;
  onReject: () => void;
  onDelete: () => void;
};

export const ActionMenu = ({
  onViewESUB,
  onAcceptAsAccount,
  onReject,
  onDelete,
}: ActionMenuProps) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        aria-label="more"
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
        style={{ padding: 0 }}
      >
        <VerticalThreeDots />
      </IconButton>
      <StyledMenu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={open}
        onClose={handleClose}
      >
        <StyledMenuItem>
          <StyledButton width="180px" onClick={onViewESUB}>
            View eSUB
          </StyledButton>
        </StyledMenuItem>
        <StyledMenuItem>
          <StyledButton width="180px" onClick={onAcceptAsAccount}>
            Accept As Account
          </StyledButton>
        </StyledMenuItem>
        <StyledMenuItem>
          <StyledButton width="180px" onClick={onReject}>
            Reject
          </StyledButton>
        </StyledMenuItem>
        <StyledMenuItem>
          <StyledButton width="180px" onClick={onDelete}>
            Delete
          </StyledButton>
        </StyledMenuItem>
      </StyledMenu>
    </>
  );
};
